(function ($) {

	let scriptLoaded = false;

	function ensurePickmappAssets(callback) {
		if (typeof window.pickmappInit === 'function') {
			if (typeof callback === 'function') callback();
			return;
		}

		if (!$('link[href*="geowidget/v/1/6/styles.min.css"]').length) {
			$('<link rel="stylesheet" href="https://pickmapp.postabezhranic.cz/template/assets/geowidget/v/1/6/styles.min.css">').appendTo('head');
		}

		if (!$('link[href*="place-autocomplete-element.css"]').length) {
			$('<link rel="stylesheet" href="https://www.gstatic.com/maps/place-autocomplete-element/v1/place-autocomplete-element.css">').appendTo('head');
		}

		if (!scriptLoaded && !$('script[src*="geowidget/v/1/6/scripts.min.js"]').length) {
			scriptLoaded = true;
			const script = document.createElement('script');
			script.src = 'https://pickmapp.postabezhranic.cz/template/assets/geowidget/v/1/6/scripts.min.js';
			script.onload = function () {
				if (typeof callback === 'function') callback();
			};
			document.body.appendChild(script);
		} else {
			const interval = setInterval(function () {
				if (typeof window.pickmappInit === 'function') {
					clearInterval(interval);
					if (typeof callback === 'function') callback();
				}
			}, 100);
		}
	}

	function getLanguage() {
		const htmlLang = $('html').attr('lang') || 'cs';
		const lang = htmlLang.substring(0, 2).toLowerCase();
		return lang === 'd2' ? 'de' : lang;
	}

	function getTranslations(lang) {
		if (lang === 'sk') {
			return {
				enter_location: "zadajte polohu",
				opening_hours_title: "Otváracia doba",
				monday: "pondelok:",
				tuesday: "utorok:",
				wednesday: "streda:",
				thursday: "štvrtok:",
				friday: "piatok:",
				saturday: "sobota:",
				sunday: "nedeľa:",
				navigate_to_location: "navigovať na miesto",
				pickup_here: "vyzdvihnem tu",
				more_info: "viac info",
				type_of_delivery: "TYP VÝDAJNÉHO MIESTA:",
				type_of_delivery_parcelbox: "parcelbox",
				type_of_delivery_parcelshop: "parcelshop",
				type_of_delivery_post: "pošta",
				payment_method: "PLATOBNÁ METÓDA:",
				payment_method_cash: "hotovosť",
				payment_method_card: "platobná karta",
				payment_method_app: "mobilná aplikácia",
				opening_hours: "OTVÁRACIA DOBA:",
				opening_hours_nonstop: "nonstop",
				opening_hours_opening: "pevne stanovená",
				parcelshop_not_found_heading: "V okolí sa nenašli žiadne parcelshopy.",
				parcelshop_not_found_info: "Zmeňte adresu alebo lokalitu v mape"
			};
		}
		if (lang === 'pl') {
			return {
				enter_location: "wpisz lokalizację",
				opening_hours_title: "Godziny otwarcia",
				monday: "poniedziałek:",
				tuesday: "wtorek:",
				wednesday: "środa:",
				thursday: "czwartek:",
				friday: "piątek:",
				saturday: "sobota:",
				sunday: "niedziela:",
				navigate_to_location: "nawiguj do miejsca",
				pickup_here: "odbierz tutaj",
				more_info: "więcej informacji",
				type_of_delivery: "TYP PUNKTU:",
				type_of_delivery_parcelbox: "paczkomat",
				type_of_delivery_parcelshop: "punkt odbioru",
				type_of_delivery_post: "poczta",
				payment_method: "PŁATNOŚĆ:",
				payment_method_cash: "gotówka",
				payment_method_card: "karta",
				payment_method_app: "aplikacja",
				opening_hours: "GODZINY OTWARCIA:",
				opening_hours_nonstop: "całodobowo",
				opening_hours_opening: "określone godziny",
				parcelshop_not_found_heading: "Nie znaleziono punktów w pobliżu.",
				parcelshop_not_found_info: "Zmień adres lub lokalizację na mapie"
			};
		}
		if (lang === 'de') {
			return {
				enter_location: "Standort eingeben",
				opening_hours_title: "Öffnungszeiten",
				monday: "Montag:",
				tuesday: "Dienstag:",
				wednesday: "Mittwoch:",
				thursday: "Donnerstag:",
				friday: "Freitag:",
				saturday: "Samstag:",
				sunday: "Sonntag:",
				navigate_to_location: "Route anzeigen",
				pickup_here: "Hier abholen",
				more_info: "Mehr Info",
				type_of_delivery: "LIEFERART:",
				type_of_delivery_parcelbox: "Paketbox",
				type_of_delivery_parcelshop: "Paketshop",
				type_of_delivery_post: "Postfiliale",
				payment_method: "ZAHLUNGSMETHODE:",
				payment_method_cash: "Bargeld",
				payment_method_card: "Karte",
				payment_method_app: "App",
				opening_hours: "ÖFFNUNGSZEITEN:",
				opening_hours_nonstop: "Rund um die Uhr",
				opening_hours_opening: "Feste Zeiten",
				parcelshop_not_found_heading: "Keine Abholstationen in der Nähe gefunden.",
				parcelshop_not_found_info: "Ändern Sie die Adresse oder den Ort auf der Karte"
			};
		}

		return {
			enter_location: "zadejte polohu",
			opening_hours_title: "Otevírací doba",
			monday: "pondělí:",
			tuesday: "úterý:",
			wednesday: "středa:",
			thursday: "čtvrtek:",
			friday: "pátek:",
			saturday: "sobota:",
			sunday: "neděle:",
			navigate_to_location: "navigovat na místo",
			pickup_here: "vyzvednu zde",
			more_info: "více info",
			type_of_delivery: "TYP VÝDEJNÍHO MÍSTA:",
			type_of_delivery_parcelbox: "parcelbox",
			type_of_delivery_parcelshop: "parcelshop",
			type_of_delivery_post: "pošta",
			payment_method: "PLATEBNÍ METODA:",
			payment_method_cash: "hotovost",
			payment_method_card: "platební karta",
			payment_method_app: "mobilní aplikace",
			opening_hours: "OTEVÍRACÍ DOBA:",
			opening_hours_nonstop: "nonstop",
			opening_hours_opening: "pevně stanovená",
			parcelshop_not_found_heading: "V okolí nenalezeny žádné parcelshopy.",
			parcelshop_not_found_info: "Změňte adresu nebo lokalitu v mapě"
		};
	}

	function getDefaultCoordinates(country) {
		country = (country || 'sk').toLowerCase();
		switch (country) {
			case 'at':
				return { lat: '48.2082', lng: '16.3738' }; // Vienna
			case 'pl':
				return { lat: '52.2297', lng: '21.0122' }; // Warsaw
			case 'cz':
				return { lat: '50.0755', lng: '14.4378' }; // Prague
			case 'sk':
			default:
				return { lat: '48.1486', lng: '17.1077' }; // Bratislava
		}
	}

	function openModal() {
		$('#pickmapp-modal').fadeIn(150, function () {
			window.dispatchEvent(new Event('resize'));
		});
		$('body').addClass('has-pickmapp-modal');
		setTimeout(function () {
			window.dispatchEvent(new Event('resize'));
		}, 250);
	}

	function closeModal() {
		$('#pickmapp-modal').fadeOut(150);
		$('body').removeClass('has-pickmapp-modal');
	}

	function initPickmappWidget(courierNumber, courierName, courierColor, country) {
		const params = window.pickmapp_widget_params || window.pickmapp_params || {};
		const apiKey = params.api_key || '79a783d8dc6b5bc8f39af1ebb0899c2e';
		const googleApiKey = params.google_api_key || '';
		const lang = getLanguage();
		const coords = getDefaultCoordinates(country);

		const parcelshops = [{
			number: courierNumber,
			filterName: courierName || 'Výdejní místo',
			filterColor: courierColor || '#ED7E1D',
			deliveryPrice: '',
			active: 1
		}];

		const config = {
			mapElementId: 'pickMapp',
			api_key: apiKey,
			googleApiKey: googleApiKey,
			parcelshops: parcelshops,
			countries: [country.toLowerCase()],
			translations: getTranslations(lang),
			defaultLlatitude: coords.lat,
			defaultLlongitude: coords.lng,
			afterParcelshopSelectCallback: function (parcelshopNumber, courier, name, address, city, zip, pIdCourier) {
				let cleanName = (name || '').trim();
				if (address && address.trim()) {
					const trimmedAddr = address.trim();
					const suffixRegex = new RegExp('[\\s–\\-,]+' + trimmedAddr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*$', 'i');
					if (suffixRegex.test(cleanName)) {
						cleanName = cleanName.replace(suffixRegex, '').trim();
					}
				}

				$("input[name='shipping_pickup_point_id']").val(parcelshopNumber);
				$("input[name='shipping_company_name']").val(cleanName);
				$("input[name='shipping_address_line_1']").val(address);
				$("input[name='shipping_city']").val(city);
				$("input[name='shipping_zip']").val(zip);
				$("input[name='shipping_pickup_point_type']").val(pIdCourier || courier || 'parcelshop');

				closeModal();
				$("input[name=shipping_method_id]").first().trigger("change");
			}
		};

		if (typeof window.pickmappInit === 'function') {
			window.pickmappInit(config);
		}
	}

	function openPickmappPickupWidget($btn) {
		const courier = $btn.data('courier') || 142;
		const courierName = $btn.data('courier-name') || 'Výdejní místo';
		const courierColor = $btn.data('courier-color') || '#ED7E1D';
		let country = $btn.data('country');

		if (!country) {
			const $countryInput = $('form#checkout__form select[name="shipping_country"], form#checkout__form input[name="shipping_country"]:checked, form#checkout__form input[name="shipping_country"]');
			country = $countryInput.val() || 'sk';
		}

		openModal();

		ensurePickmappAssets(function () {
			initPickmappWidget(courier, courierName, courierColor, country);
		});
	}

	$(document).gp_ready(function () {

		// Handle button click to open PickMapp
		$(document).off('click.pickmapp', '[data-open-pickmapp-pickup-point]').on('click.pickmapp', '[data-open-pickmapp-pickup-point]', function (e) {
			e.preventDefault();
			openPickmappPickupWidget($(this));
		});

		// Handle close modal clicks
		$(document).off('click.pickmapp_close', '#pickmapp-modal .pickmapp-modal__close, #pickmapp-modal .pickmapp-modal__backdrop')
			.on('click.pickmapp_close', '#pickmapp-modal .pickmapp-modal__close, #pickmapp-modal .pickmapp-modal__backdrop', function (e) {
				e.preventDefault();
				closeModal();
			});

		// Close on Escape key
		$(document).off('keydown.pickmapp').on('keydown.pickmapp', function (e) {
			if (e.key === 'Escape' && $('#pickmapp-modal').is(':visible')) {
				closeModal();
			}
		});

		// Preload assets if PickMapp button is present on page
		if ($('[data-open-pickmapp-pickup-point]').length > 0) {
			ensurePickmappAssets();
		}
	});

})(jQuery);
